<div class="avatar-container size-full avatar">
  @if (userAvatarUrl()) {
    <img class="size-full avatar-image object-cover" [src]="userAvatarUrl()" alt="" />
  } @else {
    <div
      class="flex size-full items-center justify-center avatar-initials text-white"
      [style.background-color]="profileColor()"
    >
      {{ initials() }}
    </div>
  }
</div>
